import React from 'react';
import LandingPage from './components/LandingPage';
import './App.css';

function App() {
  return <LandingPage />;
}

export default App;
